import { useQuery } from "@tanstack/vue-query";
import { api } from "../api";
import { keys, type ResponseType } from "../api.keys";
import type { SonicRewardsInfo } from "../types";
import { useWalletsStore } from "~/stores/wallets";

export async function getSonicRewardsInfo(wallet: string) {
  const { data } = await api.get<ResponseType<SonicRewardsInfo>>(
    "/referral/sonic-rewards/info",
    {
      params: {
        wallet,
      },
    }
  );

  return data;
}

export function useSonicRewardsInfo() {
  const wallet = useWalletsStore();
  const address = computed(() => wallet.wallet?.publicKey?.toBase58?.() || "");

  return useQuery({
    queryKey: keys.sonicRewardsInfo(unref(address)),
    queryFn: () => getSonicRewardsInfo(unref(address)),
    enabled: !!wallet.wallet && unref(address) !== "",
  });
}
